export const isVimeoOrYoutubeVide = (value: string | undefined) => {
  if (value) {
    const isYoutubeUrl = value.toLowerCase().includes("youtube") || value.toLowerCase().includes("youtu.be");
    const isVimeoUrl = value.toLowerCase().includes("vimeo");
    return isYoutubeUrl || isVimeoUrl;
  }
  return false;
};
